import { mainPageFunctions } from "./main";
import { contactWithUsFunctions } from "./contact-with-us";
import { pressCenterFunctions } from "./press-center";
import { buyFunctions } from "./buy";
import { historyFunctions } from "./history";
import { productTabsFunctions } from "./production";
import { productDetailFns } from "./product-detail";
import { serviceFns } from "./service";

export const pagesFunctions = () => {
  mainPageFunctions();
  contactWithUsFunctions();
  pressCenterFunctions();
  buyFunctions();
  historyFunctions();
  productTabsFunctions();
  productDetailFns();
  serviceFns();
};
